import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Image from '../../../components/ContentfulImage';
import Placeholder from '../../../components/Placeholder';

import {
  Wrapper,
  Title,
  RangeContainer,
  Range,
  RangeImage,
  RangeCategory,
  RangeName,
  ViewProductRange,
  Button,
  contentTypeToCategory,
  contentTypeToUrl,
} from './KeyProductLine.style';

class KeyProductLine extends React.Component {
  state = {
    visible: 4,
  };

  showMoreRanges = () => {
    this.setState(({ visible }) => ({ visible: visible + 4 }));
  };

  render() {
    const { copy, ranges, locale } = this.props;
    const { visible } = this.state;

    return (
      <Wrapper>
        <Title>{copy.key_product_line || <Placeholder w="165px" h="20px" />}</Title>

        <RangeContainer visible={visible}>
          {ranges.map(range => (
            <Range key={range.name || range.key}>
              <RangeImage>
                {range.productImage ? (
                  <Image src={range.productImage} options={{ h: '100%', w: '100%', objectFit: 'contain', size: 130 }} />
                ) : (
                  <Placeholder h="100%" w="100%" />
                )}
              </RangeImage>
              <RangeCategory>
                {contentTypeToCategory[range.contentType] || <Placeholder w="75px" h="12px" />}
              </RangeCategory>
              <RangeName>{range.name || <Placeholder w="120px" h="24px" />}</RangeName>
              <Link
                to={`/${locale}/range/${contentTypeToUrl[range.contentType]}/${range.slug}`}
                href={`/${locale}/range/${contentTypeToUrl[range.contentType]}/${range.slug}`}
              >
                <ViewProductRange>{copy.view_product_range || <Placeholder w="145px" h="15px" />}</ViewProductRange>
              </Link>
            </Range>
          ))}
        </RangeContainer>

        {ranges.length > visible && <Button onClick={this.showMoreRanges}>{copy.view_more_products}</Button>}
      </Wrapper>
    );
  }
}

KeyProductLine.defaultProps = {
  copy: {
    key_product_line: '',
    view_more_products: '',
    view_product_range: '',
  },
  ranges: [{ key: 1 }, { key: 2 }, { key: 3 }, { key: 4 }],
};

KeyProductLine.propTypes = {
  copy: PropTypes.shape({
    key_product_line: PropTypes.string,
    view_more_products: PropTypes.string,
    view_product_range: PropTypes.string,
  }),
  ranges: PropTypes.arrayOf(
    PropTypes.shape({
      heroImages: PropTypes.arrayOf(PropTypes.shape()),
    })
  ),
  locale: PropTypes.string.isRequired,
};

export default KeyProductLine;



// WEBPACK FOOTER //
// ./src/pages/HomePage/KeyProductLine/KeyProductLine.js